import type { TParagraphElement } from '@shared/dream-components';
import { ParagraphSerializer } from '@shared/dream-components';
import type { ReactNode } from 'react';
import useProductMergeTagProcessor from './hooks/useProductMergeTagProcessor';

interface Props {
  node: TParagraphElement;
  children: ReactNode | ReactNode[];
}

const Paragraph = ({ node, children }: Props) => {
  const { children: childrenToRender } = useProductMergeTagProcessor({ node, children });

  return <ParagraphSerializer element={node}>{childrenToRender}</ParagraphSerializer>;
};

export default Paragraph;
